import smoothstep from "smoothstep";

type HeartType = {
  x: number;
  y: number;
  width: number;
  height: number;
  scale: number;
  rootScale: number;
};

const heartPath = new Path2D(
  "M181.4 0c-25.5 0-55.7 18.8-74 50.2-4.9-11.3-22.5-23.7-43.4-23.7-16.8 0-64 21-64 88.9C0 203 88.6 221 106.5 248.2c1.2 1.9 5.2 3.3 6.7-1.2 14.3-42.2 125.1-89.8 125.1-175.7.1-48.1-31.4-71.3-56.9-71.3z"
);

const COLORS = ["#FF0C00", "#FE63ED", "#17E3E0"];

const BITMAPS = [new Image(), new Image(), new Image()];

const BITMAP_SIZE = 300;

// Convert Path2D to data URL
const canvas = document.createElement("canvas");
const ctx = canvas.getContext("2d");

if (ctx) {
  canvas.width = BITMAP_SIZE;
  canvas.height = BITMAP_SIZE;
  ctx.fillStyle = COLORS[0];
  ctx.fill(heartPath);
  BITMAPS[0].src = canvas.toDataURL();
  ctx.clearRect(0, 0, BITMAP_SIZE, BITMAP_SIZE);

  ctx.fillStyle = COLORS[1];
  ctx.fill(heartPath);
  BITMAPS[1].src = canvas.toDataURL();
  ctx.clearRect(0, 0, BITMAP_SIZE, BITMAP_SIZE);

  ctx.fillStyle = COLORS[2];
  ctx.fill(heartPath);
  BITMAPS[2].src = canvas.toDataURL();
}

export class Heart {
  color: string;
  noise: number;

  constructor(public props: HeartType) {
    this.props = props;
    this.color = `rgb(${Math.random() * 255}, ${Math.random() * 255}, ${
      Math.random() * 255
    })`;
    this.noise = 1;
  }

  get scale() {
    return this.props.scale;
  }

  set scale(value: number) {
    this.props.scale = value;
  }

  drawHeart(ctx: CanvasRenderingContext2D, bitmapIndex: number, scale: number) {
    const noiseScale = smoothstep(
      -Math.PI,
      Math.PI,
      Math.cos(this.noise * Math.PI * 2 * smoothstep(-1, 1, this.noise))
    );
    // const noiseScale = 1;

    const calculatedScale = scale * noiseScale * this.props.rootScale;

    const finalScale = calculatedScale * this.props.scale;
    if (finalScale <= 0) {
      return;
    }
    const xPos = this.props.x + (this.props.width / 2) * (1 - calculatedScale);
    const yPos = this.props.y + (this.props.height / 2) * (1 - calculatedScale);

    ctx.drawImage(
      BITMAPS[bitmapIndex],
      xPos,
      yPos,
      finalScale * BITMAP_SIZE,
      finalScale * BITMAP_SIZE
    );

    // ctx.transform(finalScale, 0, 0, finalScale, xPos, yPos);
    // ctx.fillStyle = color;
    // ctx.fill(heartPath);
    // ctx.setTransform(1, 0, 0, 1, 0, 0);
  }

  draw(ctx: CanvasRenderingContext2D) {
    const firstColorScale = smoothstep(0.3, -0.5, this.noise);
    const secondColorScale = smoothstep(0.8, -0.5, this.noise);
    const thirdColorScale = smoothstep(4, 0, this.noise);

    this.drawHeart(ctx, 2, thirdColorScale);
    this.drawHeart(ctx, 1, secondColorScale);
    this.drawHeart(ctx, 0, firstColorScale);

    // Draw heart bitmap on canvas
    // ctx.drawImage(BITMAPS[0], 0, 0, 300, 300);
    // ctx.drawImage(BITMAPS[1], 0, 0, 300, 300);
    // ctx.drawImage(BITMAPS[2], 0, 0, 300, 300);
  }
}
